import React, { useState, useEffect, useContext } from 'react';
import { ToggleButton, ToggleButtonGroup } from 'react-bootstrap';
import { NavLink, Link } from 'react-router-dom';
import EventSelect from 'components/MultiSelectSearch/EventSelect';
import { local_routes } from 'utils/Routes';
import {
  org_friendly_url,
  user_access_level,
  events_list_api,
  user_API,
  myHeaders_Auth_With_Cache_Control,
  apiUrl,
  user_entity_uuid
} from 'Api/Api';
import './style.css';
import DownloadAssetsButton from 'components/DownloadAssetsButton/DownloadAssetsButton';
import UserContext from 'store/UserContext';
import Select from 'react-select';
import { Button, Modal, CloseButton, Row, Col, Container } from 'react-bootstrap';
import axios from 'axios';
import { get_current_unix_stamp, assembleNickname } from 'utils/Helper';
import ShareAccessModalButton from 'components/Modals/ShareAccessModalButton';

// JBB - 82/2/2021 - make "add presentation" a button which opens a modal. On modal open, you get all the presentations for the user from API and filter by presenter_integer >= 1
//   If there is a presentation in the event presentation array where the presentation presenter matches the presenter in this component, then there is no "add presentation" button, and instead we should the presentation name as a link

function PresentationPresenterCombo(props) {
  const [presentationsArray, setPresentationsArray] = useState(); // for add presentation modal
  const [showAddPresentation, setShowAddPresentation] = useState(false);
  
  const context = useContext(UserContext);
  //const context = UserContext;

  // JBB - 8/2/2021
  const {
    //event_presentations,
    presenter_info,
    //user_event_presentation,
    event_info,
    source_owner,
    source_pathname,
    source_info
  } = props;
  const [user_event_presentation, setUserEventPresentation] = useState();
  const [editable, setEditable] = useState(props.editable);
  
  const [addingPresentation, setAddingPresentation] = useState(false);
  const [removingPresenter, setRemovingPresenter] = useState(false);
  
  let workspace_base_url = '';
  if (org_friendly_url) {
    workspace_base_url = local_routes.workspace + '/' + org_friendly_url;
  }
  
  useEffect(() => {
    setUserEventPresentation(props.presentation_info);
    setEditable(props.editable);
  }, [props.presentation_info,props.editable]);
  
  useEffect(() => {
    (async () => {
      //if (!props) {
      //  return;
      //}
      /*
      let user_event_presentation = event_presentations.filter(
        (event_presentation_obj) =>
          event_presentation_obj.users &&
          event_presentation_obj.users.some(
            (user_obj) => user_obj.entity_uuid === presenter_info.entity_uuid
          )
      ).shift();
      */
      /*
      if (user_event_presentation) {
        // is selected presentation editable?
        if (user_access_level === 'admin' || user_event_presentation.shared_access_write_uuids.includes(user_entity_uuid)) {
          setEditable(true);
        }

        if (!user_event_presentation.xref_data || !('visibility_integer' in user_event_presentation.xref_data)) {
          user_event_presentation.visibility_integer = 1;
        } else {
          user_event_presentation.visibility_integer = user_event_presentation.xref_data.visibility_integer;
        }

        setUserEventPresentation(user_event_presentation);
      }
      */
    })();
  }, []);

  //method to ADD selected presentation
  const addEventPresentation = async (item) => {
    //let totalPkLen = event_presentations.length + 1;
    //console.log('MY ITEM', item);
    let presentation_uuid = item.value.entity_uuid;
    let event_uuid = props.event_uuid;
    let patch_promises = [];
    
    // associate this presentation with the event
    let event_patch_obj = {
      trigger_create_event_pptx: true,
      presentations: [
        {
          xref_data: {
            accepted_time: get_current_unix_stamp(),
            order_integer: props.index+1
          },
          entity_uuid: presentation_uuid
        }
      ]
    };
    patch_promises.push(axios.patch(`${events_list_api}/${event_uuid}`, event_patch_obj));
    
    // if this event is associated with a location or channel, and the user has rights to edit the location/channel, then associate this presentation with it
    if (
      (source_info.entity_type === 'locations' ||
        source_info.entity_type === 'channels') &&
      (source_owner || user_access_level === 'admin')
    ) {
      let source_patch_obj = {
        presentations: [
          {
            entity_uuid: presentation_uuid,
            xref_data: {
              added_time: get_current_unix_stamp()
            }
          }
        ]
      };
      patch_promises.push(
        axios.patch(
          `${apiUrl}${source_info.entity_type}/${source_info.entity_uuid}`,
          source_patch_obj
        )
      );
    }
    await Promise.all(patch_promises);

    props.getEventPresenterData();
    
    //await props.getEventPks();
    //props.getEventPresenterData();
  };

  //method to REMOVE presentation
  const removeEventPresentation = async (data) => {
    let event_uuid = props.event_uuid;
    let presentation_uuid = data.entity_uuid;
    // delete the presentation xref from event and location
    let remove_promises = [];
    
    remove_promises.push(
      axios.delete(
        `${events_list_api}/${event_uuid}/presentations/${presentation_uuid}`
      )
    );
    
    let patch_obj = {
      trigger_create_event_pptx: true
    };
    remove_promises.push(
      axios.patch(`${events_list_api}/${event_uuid}`, patch_obj)
    );
    
    await Promise.all(remove_promises);
    
    removePresentation();
    
    props.getEventPresenterData();

    //await props.getEventPks();
  };

  const handleSelectAddPresentation = (option) => {
    setAddingPresentation(true);
    addEventPresentation(option);
    if (user_access_level === 'admin' || option.value.shared_access_write_uuids.includes(user_entity_uuid)) {
      setEditable(true);
    }
    option.value.visibility_integer = 1;

    setUserEventPresentation(option.value);
    setShowAddPresentation(false);
    setAddingPresentation(false);
  };

  const onClickRemove = async () => {
    // to remove the presenter (and presentation if there is one) from the event
    setRemovingPresenter(true); // this makes action look immediate on screen
    let remove_promises = [];
    
    // remove event->presentation association
    if (user_event_presentation) {
      remove_promises.push(
        axios.delete(
          `${events_list_api}/${event_info.entity_uuid}/presentations/${user_event_presentation.entity_uuid}`
        )
      );
    }
    
    // remove (patch) event->user association (as presenter)
    let patch_event_user_obj = {
      presenter_integer: -1,
      presenter_order_integer: -1
    };
    remove_promises.push(
      axios.patch(
        `${events_list_api}/${event_info.entity_uuid}/users/${presenter_info.entity_uuid}`, patch_event_user_obj
      )
    );
    
    // trigger event pptx regen
    let patch_event_obj = {
      trigger_create_event_pptx: true
    };
    remove_promises.push(
      axios.patch(`${events_list_api}/${event_info.entity_uuid}`, patch_event_obj)
    );
    
    await Promise.all(remove_promises);    
    
    //props.getPresenterData(props);
    
    // tell the parent about it, so it can re-render
    props.getEventPresenterData();
  };

  const getItemStyle = (draggableStyle, isDragging) => ({
    userSelect: 'none',
    padding: 0,
    margin: `0 0 0px 0`,
    background: isDragging ? '#84C9BC' : 'transparent',
    display: 'flex',
    borderBottom: '1px solid #dee2e6',
    ...draggableStyle
  });
  
  const handleClose = () => setShowAddPresentation(false);

  const renderPresentation = () => {
    return (
      <div className="d-flex align-items-center">
        <Link
          style={{ pointerEvents: user_event_presentation.status_code === 1 ? 'auto' : 'none' }}
          className="mr-1"
          to={{
            pathname: `${workspace_base_url}${local_routes.presentations}/${user_event_presentation.friendly_url}`,
            data: { source: { referrer: source_pathname } }
          }}
          target="_blank">
          {user_event_presentation.entity_name}
        </Link>{' '}
        <CloseButton
          className="btn btn-danger px-2 py-1"
          onClick={
            user_event_presentation
              ? () => removeEventPresentation(user_event_presentation)
              : removePresentation
          }
        />
      </div>
    );
  };
  
  const renderAddButton = () => {
    return (
      <Button variant="pkprimary" onClick={handleShow}>
        Add Event Presentation
      </Button>
    );
  };
  
  const removePresentation = () => {
    setUserEventPresentation(null);
  };
  
  async function handleShow() {
    let user_presentations_filter_obj = {
      status_code: {
        eq: 1
      },
      presenter_integer: {
        eq: 1
      }
    };
    /*
    if (
      event_info.event_presentation_format &&
      event_info.event_presentation_format !== 'any'
    ) {
      let [slide_count, slide_length] =
        event_info.event_presentation_format.split('x');
      user_presentations_filter_obj.slide_count = { eq: slide_count };
      user_presentations_filter_obj.slide_length = { eq: slide_length };
    }
    */
    const response = await axios.get(
      `${user_API}/${
        props.presenter_info.entity_uuid
      }/presentations?sort_obj=${encodeURIComponent(
        '{"created_time":"desc"}'
      )}&filter_obj=${encodeURIComponent(
        JSON.stringify(user_presentations_filter_obj)
      )}&limit=1000`,
      myHeaders_Auth_With_Cache_Control
    );
    
    // must filter for event presentation format here, because legacy presentations may not have those values
    if (
      event_info.event_presentation_format &&
      event_info.event_presentation_format !== 'any'
    ) {
      let [slide_count, slide_length] = event_info.event_presentation_format.split('x');
      response.data = response.data.filter((item) => {
        if (item.slide_count && item.slide_length) {
          if (item.slide_count !== parseInt(slide_count) || item.slide_length !== parseInt(slide_length)) {
            if (item.entity_uuid === '2c2fe427-2f6d-4d7c-8084-8fd0a182c1b0') {
              console.log("HMM",item.slide_count,slide_count,item.slide_length,slide_length);
            }
            return false;
          }
        }
        return true;
      });
    }
    
    console.log('MODAL RESPONSE', response.data);
    let entity_name_array = response.data.map((item) => {
      return { value: item, label: item.entity_name };
    });
    setPresentationsArray(entity_name_array);
    setShowAddPresentation(true);
  }

  const toggleVisibility = async (presentation_obj) => {
    /*
    let tmp_userPresetations = presentation_obj;
    if (tmp_userPresetations.visibility_integer) {
      tmp_userPresetations.visibility_integer = 0;
    } else {
      tmp_userPresetations.visibility_integer = 1;
    }
    */
    if (presentation_obj.visibility_integer) {
      presentation_obj.visibility_integer = 0;
    } else {
      presentation_obj.visibility_integer = 1;
    }
    setUserEventPresentation(presentation_obj);

    let patch_obj = {
      presentations: [
        {
          entity_uuid: presentation_obj.entity_uuid,
          xref_data: {
            visibility_integer: presentation_obj.visibility_integer
          }
        }
      ]
    };

    await axios.patch(`${apiUrl}events/${props.event_uuid}`, patch_obj);

    props.getEventPresenterData();
    
    // //bust cache
    // let event_presentations_params = {
    //   do_recursive: true,
    //   filter_obj: {
    //     order_integer: {
    //       gte: 1
    //     }
    //   },
    //   sort_obj: {
    //     order_integer: 'asc'
    //   }
    // };
    
    //await props.getEventPks();
  };

  const profilePic = props.presenter_info.avatar_image_url;
  const profilePlaceholder =
    'https://upload.wikimedia.org/wikipedia/commons/2/24/Missing_avatar.svg';
  const { provided, snapshot } = props;
  const centeredData =
    'border-none px-1 d-flex align-items-center justify-content-center';
    
  return (
    <React.Fragment>
      { removingPresenter ? <React.Fragment></React.Fragment> :
      <tr
        className="drag-point"
        ref={provided.innerRef}
        style={getItemStyle(provided.draggableStyle, snapshot.isDragging)}
        {...provided.dragHandleProps}>
        <td className="border-none" style={{ width: '25%' }}>

          <Row>
            <div style={{ alignSelf: 'center', fontSize: 'smaller', color: 'gray', marginRight: '5px' }}>
              {props.index + 1}
              {')'}
            </div>
          
            <div style={{ justifySelf: 'left' }}>          

            <img
              src={profilePic ? profilePic : profilePlaceholder}
              alt="profile pic"
              style={{ height: '45px', width: '45px', borderRadius: '100%', marginRight: "5px" }}
            />
            </div>
            <div style={{ alignSelf: 'center' }}>
              <Link
                style={{ pointerEvents: props.presenter_info.status_code === 1 ? 'auto' : 'none' }}
                target="_blank"
                to={`${workspace_base_url}${local_routes.users}/${props.presenter_info.friendly_url}`}
              >

                <span style={{ whiteSpace: 'nowrap' }}>{assembleNickname(props.presenter_info)}<br/><span style={{ fontSize: 'smaller' }}>{props.presenter_info.friendly_url}</span></span>
              </Link>
            </div>
          </Row>

        </td>
        <td className={`${centeredData}`} style={{ width: '25%' }}>
          {!user_event_presentation ? renderAddButton() : renderPresentation()}
          <Modal show={showAddPresentation} onHide={handleClose} animation={false}>
            <Modal.Header closeButton>
              <Modal.Title>Add Event Presentation</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Select
                  style={{ color: 'black', backgroundColor: 'white' }}
                  options={presentationsArray ? presentationsArray : null}
                  onChange={handleSelectAddPresentation}
                  closeMenuOnSelect={true}
                  isDisabled={addingPresentation}
                />
              <p className="my-3">
                If the presenter hasn't already created a presentation, you
                can create one for them.
              </p>
            </Modal.Body>
            <Modal.Footer className="d-flex justify-content-center">
                <Link
                  to={{
                    pathname: `${workspace_base_url}${local_routes.pkcreation}`,
                    data: {
                      source: {
                        referrer: source_pathname,
                        presenter_entity_uuid: props.presenter_info.entity_uuid,
                        submit_event_uuid: props.event_uuid
                      }
                    }
                  }}>
                  <Button variant="pkprimary" disabled={addingPresentation}>
                    Create Event Presentation
                  </Button>
                </Link>
            </Modal.Footer>
          </Modal>
        </td>
        <td className={`${centeredData}`} style={{ width: '9%' }}>
          {(user_event_presentation && editable) ? (
            <Link
              // data-tip={this.state.presentationDetail.organizations_uuid && !this.workspace_base_url && 'Please Edit from Team View'}
              to={{
                pathname: `${workspace_base_url}${local_routes.pkcreation}/${user_event_presentation.entity_uuid}/description`,
                data: {
                  source: {
                    referrer: source_pathname
                  }
                }
              }}>
              <Button
                variant="pkprimary"
                // style={{ marginRight: "5px", marginBottom: "1px" }}
              >
                Edit
              </Button>
            </Link>
          ) : (
            '-'
          )}
        </td>
        <td className={`${centeredData}`} style={{ width: '9%' }}>
          {user_event_presentation ? (
            <DownloadAssetsButton
              entity_info={{
                ...user_event_presentation,
                entity_type: 'presentations',
                editable
              }}
            />
          ) : (
            '-'
          )}
        </td>
        <td className={`${centeredData}`} style={{ width: '9%' }}>
          {editable && user_event_presentation ? (
            <ShareAccessModalButton
              entity_info={{
                ...user_event_presentation,
                entity_type: 'presentations'
              }}
            />
          ) : (
            '-'
          )}
        </td>
        <td className={`${centeredData}`} style={{ width: '13%' }}>
          {user_event_presentation ? (
            <ToggleButtonGroup
              size="sm"
              type="radio"
              name="visibility_integer"
              //value={
              //  user_event_presentation.visibility_integer
              //    ? user_event_presentation.visibility_integer
              //    : 0
              //}
              value={user_event_presentation.visibility_integer}
              onChange={() =>
                toggleVisibility(user_event_presentation)
              }>
              <ToggleButton
                variant={
                  context.theme === 'dark' ? 'outline-light' : 'outline-dark'
                }
                value={1}>
                {user_event_presentation.visibility_integer ? 'Shown' : 'Show'}
              </ToggleButton>
              <ToggleButton
                variant={
                  context.theme === 'dark' ? 'outline-light' : 'outline-dark'
                }
                value={0}>
                {user_event_presentation.visibility_integer ? 'Hide' : 'Hidden'}
              </ToggleButton>
            </ToggleButtonGroup>
          ) : (
            '-'
          )}
        </td>
        <td style={{ width: '10%' }} className={`pkButtons ${centeredData}`}>
          <div>
            <CloseButton
              className="btn btn-danger px-3 py-2"
              onClick={onClickRemove}
            />
          </div>
        </td>
      </tr>
      }

      {provided.placeholder ? (
        <tr>
          <td>{provided.placeholder}</td>
        </tr>
      ) : null}
      
    </React.Fragment>
  );
}

export default PresentationPresenterCombo;
